import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">观众口碑</h2>
          <p className="mt-2 text-sm text-foreground-500">听听观众怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {commentItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg p-5 md:p-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-[10px] ${i < item.rating ? 'text-accent-500 ri-star-fill' : 'text-background-300 ri-star-line'}`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              <div className="mt-3 text-xs text-foreground-400">{item.date}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}